import React, { useEffect, useState } from 'react'
import { AutoComplete, Button, Dropdown, Input, Space, Switch } from 'antd';
import CustomDropDownAutoComplete from '../AntD/DropDown';
import { useLocation } from 'react-router-dom'; // Import useLocation to check the current route

import './TableFilter.css';
import Services from '../../Services';
const { Search } = Input;
const TableFilters = ({ setFilters, filters }) => {

    const {
        employee
    } = Services;
    const [employees, setEmployees] = useState([])
    const location = useLocation(); // Get the current location

    const fetchEmployees = async () => {
        let result = await employee.get_employee_listing_not_Terminated()
        if (result?.httpStatus != 200) return
        const data = result?.data.map((item, index) => {
            return {
                label: `${item?.firstName} ${item?.lastName}`,
                value: item?.id
            }
        })
        setEmployees(data)
    }

    const OpenCloseOptions = [
        {
            label: 'All',
            value: null,
        },
        {
            label: 'Close',
            value: "Closed",
        },
        {
            label: 'Open',
            value: 'Approved',
        },
        {
            label: 'Pending',
            value: 'Approval-Pending',
        }
    ]
    const SourceOptions = [
        {
            label: 'All',
            value: null,
        },
        {
            label: 'Tck - Email',
            value: 1,
        },
        {
            label: 'Tck - Portal',
            value: 2,
        },
        {
            label: 'Tsk - HOS',
            value: 3,
        }
    ]

    // const OnChange = (value, type) => setFilters((prev) => ({ ...prev, [type]: value }))
    // const resetFilters = () => setFilters({ Status: null, FEmployeeId: null, TicketSourceId: null })
    // useEffect(() => {
    //     fetchEmployees()
    // }, [])
    const resetFilters = () => {
        const defaultFilters = { Status: null, FEmployeeId: null, TicketSourceId: null };
        setFilters(defaultFilters);
        localStorage.removeItem('payrollFilters'); // Clear filters from local storage
    };

    const OnChange = (value, type) => {
        const newFilters = { ...filters, [type]: value };
        setFilters(newFilters);
        localStorage.setItem('payrollFilters', JSON.stringify(newFilters));
    };

 
    useEffect(() => {
        fetchEmployees();

        const savedFilters = JSON.parse(localStorage.getItem('payrollFilters'));
        const lastRoute = localStorage.getItem('last_route');

        if (lastRoute === '/payroll/ticket' && savedFilters) {
            // If coming back from '/payroll/ticket', use saved filters
            setFilters(savedFilters);
        } else {
            // If coming from a different route, set default filters
            const defaultFilters = { Status: null, FEmployeeId: null, TicketSourceId: null };
            setFilters(defaultFilters);
            // Clear local storage since the user is not coming from the ticket page
            localStorage.removeItem('payrollFilters');
        }

        // Update last_route in local storage
        localStorage.setItem('last_route', location.pathname);
    }, [location.pathname]);
    return (
        <div style={{
            margin: "10px 0px",
            display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", flexWrap: "wrap"
        }}>
            {
                <div style={{
                    // padding: "20px",
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    flexWrap: "wrap"
                }}>
                    <CustomDropDownAutoComplete
                        items={employees}
                        setSelectedName={(value) => OnChange(value, 'FEmployeeId')}
                        selectedName={filters?.FEmployeeId || "Requested For"}
                        id="requestedForID"
                        width='200px' />
                    <CustomDropDownAutoComplete
                        items={SourceOptions}
                        setSelectedName={(value) => OnChange(value, 'TicketSourceId')}
                        selectedName={filters?.TicketSourceId || "Source"}
                        id="source"
                        width='120px' />
                    <CustomDropDownAutoComplete
                        items={OpenCloseOptions}
                        setSelectedName={(value) => OnChange(value, 'Status')}
                        selectedName={filters?.Status || "Open/Close"}
                        id="Status"
                        width='180px'
                    />
                </div>
            }
            <Button onClick={resetFilters} style={{ width: '100px', backgroundColor: "#2963ad", color: "white" }}>
                Reset
            </Button>
        </div>
    )
}
export default TableFilters


